/* Core & libraries */
import React, { useMemo, useState } from "react";
import { useTheme } from "react-jss";
import { useFormikContext } from "formik";
import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */
import { useNotificationContext } from "contexts/notificationContext";
import { useGenericApiFetch } from "endpoints/base";

/* Components */
import EditUCInputModal from "components/modals/editUcInputModal";
import { ReactComponent as EditSvg } from 'resources/images/edit.svg';

/* Styles */
import styles from "./styles.js"
import { useHasPermission } from "hooks/useHasPermission";

const UCInputModal = props => {
  const {
    value,
    className = "",
    placeholder = "",
    onChange,
    onClick,
    disabled,
    autocomplete,
    name,
    travelerDetails,
    inputRef,
    icon = <EditSvg/>,
    editUrlEndpoint,
    method = 'PATCH',
    refetch = () => undefined,
    permission
  } = props;

  const [showEditUCInputModal, setShowEditUCInputModal] = useState(false);

  const { checkPermission } = useHasPermission();
  const { genericApiFetch } = useGenericApiFetch();
  const formikContext = useFormikContext();

  const fullName = useMemo(() => `${formikContext.values?.firstName} ${formikContext.values?.lastName}`, [formikContext.values?.firstName, formikContext.values?.lastName])
  const theme = useTheme();
  const classes = styles({ theme });
  const { setNotification } = useNotificationContext();

  const triggerModal = () => {
    if (travelerDetails?.userStatus !== "REMOVED") {
      setShowEditUCInputModal(true)
    }
  }
  const handleSubmit = async (values, actions) => {
    const response = await genericApiFetch({
      url: editUrlEndpoint,
      method,
      data: values,
      spinner: "editUcInputModalSpinner"
    });
    if (response.success) {
      actions.setSubmitting(false);
      setShowEditUCInputModal(false);
      setNotification(
        "success",
        <FormattedMessage id="edit.UC.input.modal.success.title" values={{ fieldLabel: placeholder }}/>,
        <FormattedMessage id="edit.UC.input.modal.success.subtitle" values={{ fieldLabel: placeholder }}/>
      )

      refetch(values);
      return true
    }

    setNotification(
      "error",
      <FormattedMessage id="edit.UC.input.modal.error.title" values={{ fieldLabel: placeholder }}/>,
      <FormattedMessage id="edit.UC.input.modal.error.subtitle" values={{ fieldLabel: placeholder }}/>
    )

    return false;
  };

  const hasPermission = useMemo(() => permission ? checkPermission(permission) : true, [permission]);

  return (
    <div className={classes.inputWrapper}>
      <input
        className={`${classes.input} ${className} ${hasPermission && classes.editableInput}`}
        placeholder={placeholder}
        onChange={onChange}
        onClick={onClick}
        disabled={disabled}
        autoComplete={autocomplete}
        name={name}
        ref={inputRef}
        value={value}
      />
      {hasPermission ? <>
        <span className={travelerDetails?.userStatus === "REMOVED" ? `${classes.icon} ${classes.disabledIcon}` : classes.icon} onClick={ triggerModal }>{icon}</span>
        <EditUCInputModal
          showModal={showEditUCInputModal}
          setShowModal={setShowEditUCInputModal}
          handleSubmit={handleSubmit}
          fieldName={name}
          fieldLabel={placeholder}
          value={value}
          fullName={fullName}
        />
      </> : null}
    </div>
  )
}

export default UCInputModal;
